import { Stack, StackProps } from '@mui/material';
import { PageLayout, TransparentChip } from './common';
import { MessagesList } from './messages/MessagesList';
import { Message } from './types/messages';

export const DummyMessages = [
  /* {
       id: '1',
       title: 'U Vaší události 38823123 očekáváme doložení dokumentů k dořešení události',
       createdDate: '2011-10-05T14:48:00.000Z',
       isNew: true
     },
     {
       id: '2',
       title: 'U Vaší události 38823123 očekáváme doložení dokumentů k dořešení události',
       createdDate: '2011-10-05T14:48:00.000Z',
       isNew: false
     }*/
];

export interface MessagesTagsProps extends StackProps {
  message: Pick<Message, 'isNew'>;
}

export const MessagesTags = ({ message: { isNew }, ...props }: MessagesTagsProps) => (
  <Stack direction="row" spacing={2} alignItems="center" {...props}>
    {isNew && <TransparentChip size="small" label="Nová" color="success" variant="filled" />}
  </Stack>
);

export const MessagesPage = () => (
  <PageLayout title="Zprávy z RPS" withContentBlock>
    <Stack spacing={2} height={1}>
      <MessagesList messages={DummyMessages} />
    </Stack>
  </PageLayout>
);
